import combineSpecsWithTooltips from 'helpers/combine-specs-with-tooltips'

export const getSpecsWithTooltips = ({ specifications = [], specTips = []}) =>
  specifications ?
    specTips ? combineSpecsWithTooltips({ specifications, specTips }) : specifications
    : []

export const getSplitedSpecs = ({ specifications = [], specTips = [], specificationsToDisplay }) => {
  const specsWithTooltips = getSpecsWithTooltips({ specifications, specTips })

  return Number(specificationsToDisplay) === 0 ?
    { mainSpecs: specsWithTooltips } :
    {
      mainSpecs: specsWithTooltips.slice(0, specificationsToDisplay),
      additionalSpecs: specsWithTooltips.slice(specificationsToDisplay)
    }
}
